import { z } from "zod";

export const workNoteSchema = z.object({
  visitDate: z.date({ required_error: "Visit date is required" }),
  excuseStartDate: z.date().nullable().optional(),
  excuseEndDate: z.date().nullable().optional(),
  returnToWorkDate: z.date().nullable().optional(),
  reason: z.string().nonempty("Reason is required"),
});

export type WorkNoteFormValues = z.infer<typeof workNoteSchema>;
